export interface College {
  id: string;
  name: string;
  location: {
    city: string;
    state: string;
  };
  tuition: {
    inState: number | null;
    outOfState: number | null;
  };
  sat: {
    min: number | null;
    max: number | null;
  };
  gpa: {
    min: number | null;
    max: number | null;
  };
  size: "Small" | "Medium" | "Large";
  campusType: "Urban" | "Suburban" | "Rural";
  acceptanceRate: number | null;
  description: string;
  majors: string[];
  logo: string;
}

export const colleges: College[] = [
  {
    id: "1",
    name: "Princeton University",
    location: { city: "Princeton", state: "NJ" },
    tuition: { inState: 57410, outOfState: 57410 },
    sat: { min: 1460, max: 1570 },
    gpa: { min: 3.9, max: 4.0 },
    size: "Medium",
    campusType: "Suburban",
    acceptanceRate: 5.8,
    description:
      "Elite Ivy League institution known for exceptional undergraduate focus, leading research programs, and beautiful Gothic campus architecture.",
    majors: [
      "Computer Science",
      "Economics",
      "Engineering",
      "Mathematics",
      "Public Policy",
    ],
    logo: "🎓",
  },
  {
    id: "2",
    name: "Stanford University",
    location: { city: "Stanford", state: "CA" },
    tuition: { inState: 56169, outOfState: 56169 },
    sat: { min: 1440, max: 1570 },
    gpa: { min: 3.9, max: 4.0 },
    size: "Large",
    campusType: "Suburban",
    acceptanceRate: 3.9,
    description:
      "World-renowned research university in Silicon Valley, fostering innovation, entrepreneurship, and interdisciplinary collaboration across all fields.",
    majors: [
      "Computer Science",
      "Engineering",
      "Business",
      "Biology",
      "Psychology",
    ],
    logo: "🌲",
  },
  {
    id: "3",
    name: "MIT",
    location: { city: "Cambridge", state: "MA" },
    tuition: { inState: 55510, outOfState: 55510 },
    sat: { min: 1500, max: 1570 },
    gpa: { min: 3.9, max: 4.0 },
    size: "Medium",
    campusType: "Urban",
    acceptanceRate: 4.1,
    description:
      "Leading institution for science, technology, and engineering with hands-on learning culture, cutting-edge research facilities, and entrepreneurial ecosystem.",
    majors: [
      "Computer Science",
      "Engineering",
      "Mathematics",
      "Physics",
      "Economics",
    ],
    logo: "🔬",
  },
  {
    id: "4",
    name: "Harvard University",
    location: { city: "Cambridge", state: "MA" },
    tuition: { inState: 54002, outOfState: 54002 },
    sat: { min: 1460, max: 1580 },
    gpa: { min: 3.9, max: 4.0 },
    size: "Large",
    campusType: "Urban",
    acceptanceRate: 3.4,
    description:
      "Prestigious Ivy League university with unparalleled resources, diverse academic programs, and influential alumni network spanning every field.",
    majors: [
      "Economics",
      "Government",
      "Computer Science",
      "Biology",
      "Psychology",
    ],
    logo: "🏛️",
  },
  {
    id: "5",
    name: "Yale University",
    location: { city: "New Haven", state: "CT" },
    tuition: { inState: 59950, outOfState: 59950 },
    sat: { min: 1460, max: 1580 },
    gpa: { min: 3.9, max: 4.0 },
    size: "Medium",
    campusType: "Urban",
    acceptanceRate: 4.6,
    description:
      "Distinguished Ivy League institution featuring residential college system, world-class arts programs, and strong liberal arts foundation with professional schools.",
    majors: ["Political Science", "History", "Economics", "English", "Biology"],
    logo: "📚",
  },
  {
    id: "6",
    name: "University of California, Berkeley",
    location: { city: "Berkeley", state: "CA" },
    tuition: { inState: 14226, outOfState: 43980 },
    sat: { min: 1330, max: 1530 },
    gpa: { min: 3.7, max: 4.0 },
    size: "Large",
    campusType: "Urban",
    acceptanceRate: 14.5,
    description:
      "Top public research university known for academic excellence, groundbreaking research, activism culture, and proximity to San Francisco Bay Area opportunities.",
    majors: [
      "Computer Science",
      "Engineering",
      "Economics",
      "Business",
      "Data Science",
    ],
    logo: "🐻",
  },
  {
    id: "7",
    name: "Columbia University",
    location: { city: "New York", state: "NY" },
    tuition: { inState: 63530, outOfState: 63530 },
    sat: { min: 1450, max: 1560 },
    gpa: { min: 3.8, max: 4.0 },
    size: "Medium",
    campusType: "Urban",
    acceptanceRate: 3.7,
    description:
      "Ivy League university in Manhattan offering Core Curriculum, access to NYC cultural institutions, and strong programs in journalism, business, and international affairs.",
    majors: [
      "Economics",
      "Political Science",
      "Computer Science",
      "Engineering",
      "English",
    ],
    logo: "🗽",
  },
  {
    id: "8",
    name: "University of Michigan",
    location: { city: "Ann Arbor", state: "MI" },
    tuition: { inState: 15948, outOfState: 52266 },
    sat: { min: 1340, max: 1530 },
    gpa: { min: 3.7, max: 4.0 },
    size: "Large",
    campusType: "Suburban",
    acceptanceRate: 17.7,
    description:
      "Premier public research university with exceptional programs across disciplines, vibrant campus life, strong athletics, and collaborative academic environment.",
    majors: [
      "Engineering",
      "Business",
      "Psychology",
      "Computer Science",
      "Political Science",
    ],
    logo: "〽️",
  },
  {
    id: "9",
    name: "Duke University",
    location: { city: "Durham", state: "NC" },
    tuition: { inState: 60435, outOfState: 60435 },
    sat: { min: 1470, max: 1570 },
    gpa: { min: 3.8, max: 4.0 },
    size: "Medium",
    campusType: "Suburban",
    acceptanceRate: 6.2,
    description:
      "Elite research university combining academic rigor with strong athletics, beautiful Gothic campus, innovative research opportunities, and collaborative spirit.",
    majors: [
      "Computer Science",
      "Public Policy",
      "Engineering",
      "Economics",
      "Biology",
    ],
    logo: "👑",
  },
  {
    id: "10",
    name: "Northwestern University",
    location: { city: "Evanston", state: "IL" },
    tuition: { inState: 60768, outOfState: 60768 },
    sat: { min: 1440, max: 1550 },
    gpa: { min: 3.8, max: 4.0 },
    size: "Medium",
    campusType: "Suburban",
    acceptanceRate: 7.0,
    description:
      "Top-tier research university on Lake Michigan shore, known for journalism, engineering, business, and strong Chicago connections with collaborative academic culture.",
    majors: [
      "Engineering",
      "Economics",
      "Journalism",
      "Computer Science",
      "Psychology",
    ],
    logo: "🌊",
  },
  {
    id: "11",
    name: "Cornell University",
    location: { city: "Ithaca", state: "NY" },
    tuition: { inState: 59316, outOfState: 59316 },
    sat: { min: 1400, max: 1560 },
    gpa: { min: 3.7, max: 4.0 },
    size: "Large",
    campusType: "Rural",
    acceptanceRate: 8.7,
    description:
      "Ivy League land-grant university offering diverse programs across seven colleges, stunning natural setting, and strong emphasis on hands-on learning.",
    majors: [
      "Engineering",
      "Agriculture",
      "Hotel Management",
      "Architecture",
      "Computer Science",
    ],
    logo: "🦅",
  },
  {
    id: "12",
    name: "University of Texas at Austin",
    location: { city: "Austin", state: "TX" },
    tuition: { inState: 11752, outOfState: 39766 },
    sat: { min: 1240, max: 1470 },
    gpa: { min: 3.5, max: 4.0 },
    size: "Large",
    campusType: "Urban",
    acceptanceRate: 31.0,
    description:
      "Major public research university in vibrant tech hub, offering strong programs in business, engineering, liberal arts with incredible school spirit.",
    majors: [
      "Business",
      "Engineering",
      "Computer Science",
      "Communications",
      "Liberal Arts",
    ],
    logo: "🤘",
  },
  {
    id: "13",
    name: "Carnegie Mellon University",
    location: { city: "Pittsburgh", state: "PA" },
    tuition: { inState: 59864, outOfState: 59864 },
    sat: { min: 1460, max: 1560 },
    gpa: { min: 3.8, max: 4.0 },
    size: "Medium",
    campusType: "Urban",
    acceptanceRate: 13.3,
    description:
      "Leading institution for computer science, engineering, and performing arts with collaborative environment, innovative research, and strong industry partnerships.",
    majors: [
      "Computer Science",
      "Engineering",
      "Business",
      "Drama",
      "Robotics",
    ],
    logo: "🤖",
  },
  {
    id: "14",
    name: "University of Virginia",
    location: { city: "Charlottesville", state: "VA" },
    tuition: { inState: 17653, outOfState: 51118 },
    sat: { min: 1340, max: 1510 },
    gpa: { min: 3.7, max: 4.0 },
    size: "Large",
    campusType: "Suburban",
    acceptanceRate: 19.0,
    description:
      "Historic public university founded by Thomas Jefferson, featuring honor code tradition, beautiful grounds, strong liberal arts, and vibrant student life.",
    majors: ["Business", "Economics", "Engineering", "Government", "English"],
    logo: "⚔️",
  },
  {
    id: "15",
    name: "Rice University",
    location: { city: "Houston", state: "TX" },
    tuition: { inState: 52070, outOfState: 52070 },
    sat: { min: 1470, max: 1570 },
    gpa: { min: 3.8, max: 4.0 },
    size: "Small",
    campusType: "Urban",
    acceptanceRate: 8.7,
    description:
      "Elite private research university with residential college system, strong science and engineering programs, collaborative culture, and excellent Houston location.",
    majors: [
      "Engineering",
      "Computer Science",
      "Architecture",
      "Economics",
      "Biology",
    ],
    logo: "🦉",
  },
  {
    id: "16",
    name: "Vanderbilt University",
    location: { city: "Nashville", state: "TN" },
    tuition: { inState: 58130, outOfState: 58130 },
    sat: { min: 1450, max: 1570 },
    gpa: { min: 3.8, max: 4.0 },
    size: "Medium",
    campusType: "Urban",
    acceptanceRate: 6.7,
    description:
      "Top research university in Music City offering strong academics, beautiful campus, collaborative atmosphere, and access to Nashville cultural scene.",
    majors: ["Economics", "Engineering", "Education", "Business", "Medicine"],
    logo: "⚓",
  },
  {
    id: "17",
    name: "University of North Carolina at Chapel Hill",
    location: { city: "Chapel Hill", state: "NC" },
    tuition: { inState: 8980, outOfState: 36159 },
    sat: { min: 1330, max: 1500 },
    gpa: { min: 3.6, max: 4.0 },
    size: "Large",
    campusType: "Suburban",
    acceptanceRate: 19.2,
    description:
      "Historic public university offering strong liberal arts foundation, research opportunities, vibrant college town atmosphere, and exceptional value for in-state students.",
    majors: [
      "Business",
      "Biology",
      "Psychology",
      "Journalism",
      "Public Health",
    ],
    logo: "🐏",
  },
  {
    id: "18",
    name: "Emory University",
    location: { city: "Atlanta", state: "GA" },
    tuition: { inState: 55468, outOfState: 55468 },
    sat: { min: 1390, max: 1530 },
    gpa: { min: 3.7, max: 4.0 },
    size: "Medium",
    campusType: "Suburban",
    acceptanceRate: 11.4,
    description:
      "Leading research university in Atlanta with strengths in medicine, business, liberal arts, and global health, offering collaborative academic environment.",
    majors: [
      "Business",
      "Biology",
      "Nursing",
      "Psychology",
      "Political Science",
    ],
    logo: "🦅",
  },
  {
    id: "19",
    name: "University of Southern California",
    location: { city: "Los Angeles", state: "CA" },
    tuition: { inState: 60446, outOfState: 60446 },
    sat: { min: 1360, max: 1530 },
    gpa: { min: 3.7, max: 4.0 },
    size: "Large",
    campusType: "Urban",
    acceptanceRate: 12.4,
    description:
      "Major private research university in LA with strong programs in cinema, engineering, business, and exceptional alumni network in entertainment and tech industries.",
    majors: [
      "Cinema",
      "Business",
      "Engineering",
      "Communications",
      "Computer Science",
    ],
    logo: "✌️",
  },
  {
    id: "20",
    name: "Boston University",
    location: { city: "Boston", state: "MA" },
    tuition: { inState: 58560, outOfState: 58560 },
    sat: { min: 1350, max: 1500 },
    gpa: { min: 3.6, max: 4.0 },
    size: "Large",
    campusType: "Urban",
    acceptanceRate: 18.3,
    description:
      "Large private research university along the Charles River offering diverse programs, urban Boston location, and strong international student community.",
    majors: [
      "Business",
      "Communications",
      "Engineering",
      "Biology",
      "International Relations",
    ],
    logo: "🐕",
  },
];

export const usStates = [
  "AL",
  "AK",
  "AZ",
  "AR",
  "CA",
  "CO",
  "CT",
  "DE",
  "FL",
  "GA",
  "HI",
  "ID",
  "IL",
  "IN",
  "IA",
  "KS",
  "KY",
  "LA",
  "ME",
  "MD",
  "MA",
  "MI",
  "MN",
  "MS",
  "MO",
  "MT",
  "NE",
  "NV",
  "NH",
  "NJ",
  "NM",
  "NY",
  "NC",
  "ND",
  "OH",
  "OK",
  "OR",
  "PA",
  "RI",
  "SC",
  "SD",
  "TN",
  "TX",
  "UT",
  "VT",
  "VA",
  "WA",
  "WV",
  "WI",
  "WY",
];

export const allMajors = [
  "Undecided",
  "Computer Science",
  "Engineering",
  "Business",
  "Economics",
  "Biology",
  "Psychology",
  "Political Science",
  "English",
  "Mathematics",
  "Physics",
  "Chemistry",
  "History",
  "Architecture",
  "Communications",
  "Nursing",
  "Education",
  "Public Policy",
  "International Relations",
  "Art",
  "Music",
  "Theater",
  "Philosophy",
  "Sociology",
  "Anthropology",
  "Environmental Science",
];
